import React from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  showPasswordToggle?: boolean;
  onPasswordToggle?: () => void;
  showPassword?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  icon,
  showPasswordToggle,
  onPasswordToggle,
  showPassword,
  className,
  type,
  ...props
}) => {
  const inputClasses = clsx(
    'w-full px-4 py-3 bg-brand-beige-tint-2 border-0 text-black placeholder-text-grey',
    'focus:outline-none focus:ring-2 focus:ring-brand-blue focus:ring-offset-1',
    'transition-all duration-200 rounded-xl',
    icon && 'pl-12',
    showPasswordToggle && 'pr-12',
    error && 'ring-4 ring-alert-error/50 border-alert-error',
    className,
  );

  return (
    <div className="space-y-3">
      {label && <label className="block text-sm font-semibold text-brand-blue">{label}</label>}
      <div className="relative group">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-brand-blue/60 group-focus-within:text-brand-blue transition-colors">
            {icon}
          </div>
        )}
        <input
          type={showPasswordToggle ? (showPassword ? 'text' : 'password') : type}
          className={inputClasses}
          {...props}
        />
        {showPasswordToggle && onPasswordToggle && (
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-4 flex items-center text-brand-blue/60 hover:text-brand-blue transition-colors"
            onClick={onPasswordToggle}
          >
            {showPassword ? (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
            )}
          </button>
        )}
      </div>
      {error && <p className="text-sm text-alert-error">{error}</p>}
    </div>
  );
};
